"use strict";
/*
 * This file is part of the Wrzasq.pl.
 *
 * @copyright 2016, 2018 - 2019, 2024 - 2025 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuCookieNotice = void 0;
const MILISECONDS_PER_YEAR = 31536000000;
class EuCookieNotice {
    constructor(container) {
        this.close = () => {
            const date = new Date();
            date.setTime(date.getTime() + MILISECONDS_PER_YEAR);
            document.cookie = `stupidEu0=1; expires=${date.toUTCString()}; path=/`;
            this.closed = true;
            this.render();
        };
        this.container = container;
        this.closed = document.cookie.includes("stupidEu0=");
        this.content = this.buildContent();
    }
    render() {
        if (this.closed) {
            if (this.content.parentNode) {
                this.content.parentNode.removeChild(this.content);
            }
        }
        else {
            this.container.appendChild(this.content);
        }
    }
    buildContent() {
        const text = document.createElement("p");
        text.textContent = "This website utilizes cookies files They are small files stores on your computer - by " +
            "staying on the website and/or continuing browsing the service you allow us to store these files.";
        const close = document.createElement("span");
        close.textContent = "Close";
        close.onclick = this.close;
        const content = document.createElement("div");
        content.id = "stupid-eu";
        content.appendChild(close);
        content.appendChild(text);
        return content;
    }
}
exports.EuCookieNotice = EuCookieNotice;
